/**
 * Resolve a configurator-v3 public asset path.
 *
 * The standalone app's assets were copied into `public/assets/config-v3/`, so a
 * bare file name (`opt-global.png`) or an old absolute path (`/assets/opt-global.png`)
 * both resolve under that folder. API-sourced URLs (full `https://…` CDN links)
 * are returned untouched.
 */
const BASE = '/assets/config-v3/';

export function asset(path: string): string {
  if (/^https?:\/\//.test(path)) return path;
  return `${BASE}${path.replace(/^\/+(assets\/)?/, '')}`;
}
